import React, { PureComponent } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
import { scenes } from '../../colors';
import { fontMap } from './constant';
import { scale } from '../../responsive';
export default class Icon extends PureComponent {
    /**
     * 获取图片
     * @param name
     */
    static getIcon(name) {
        // 图标名存在时，返回对应编码
        if (fontMap[name]) {
            return fontMap[name];
        }
        // eslint-disable-next-line no-console
        console.warn(`[Icon]：名称 "${name}" 不在默认配置中，无法正常展示；详情参考：http://ued.qunar.com/qrn/q-design-theme/Icon/index.html`);
        return '';
    }
    render() {
        const { touchable, name, onPress, onLayout, style, needScale = false, useText = false, accessibilityPreName = '' } = this.props;
        const Container = touchable ? TouchableOpacity : View;
        const props = touchable ? { onPress } : null;
        // 直接用Text展示Icon
        if (useText) {
            return (<Text accessible={false} onPress={onPress} onLayout={onLayout} {...qAccessibilityLabel(`${accessibilityPreName}qdIcon`)} style={[...this.computeStyle(), style]}>
                    {Icon.getIcon(name)}
                </Text>);
        }
        const paddingTop = { paddingTop: scale(3, needScale) };
        return (<Container {...props} onLayout={onLayout} style={[paddingTop, style]}>
                <Text {...qAccessibilityLabel(`${accessibilityPreName}qdIcon`)} style={this.computeStyle()}>
                    {Icon.getIcon(name)}
                </Text>
            </Container>);
    }
    /**
     * 计算字体样式
     */
    computeStyle() {
        const { color, size = 16, needScale = false } = this.props;
        return [
            styles.font,
            styles.text,
            { color },
            { fontSize: scale(size, needScale) }
        ];
    }
}
Icon.defaultProps = {
    name: '',
    color: scenes.baseColor.black,
    size: 16,
    touchable: false,
    needScale: false,
    useText: false,
    onPress: () => { },
    onLayout: () => { }
};
const styles = StyleSheet.create({
    font: {
        fontFamily: 'q_design_font-0_0_14',
        backgroundColor: 'transparent'
    },
    text: {
        textAlignVertical: 'center',
        includeFontPadding: false
    }
});
